<template>
  <div class="form-group">
    <label class="small mb-1" >{{title}}</label>
    <textarea :rows="rows" class="form-control" :id="id"  :placeholder="placeholder" v-model="data" v-on:change="dataChanged"></textarea>
  </div>
</template>

<script>
export default {
  name: 'Textarea',
  data () {
    return {
      data: this.model
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },

    model: {
      type: String
    },
    rows: {
      type: Number,
      default: 10
    },
    id: {
      type: String,
      default: new Date().getMilliseconds().toString()
    }
  },
  methods: {
    dataChanged (d) {
      this.data = d.target.value
      this.$emit('datachanged', this.data, this.name)
    }
  },
  watch: {
    model: function (data) {
      this.data = data
    }
  }
}
</script>

<style scoped>

</style>
